/**
 * @generated SignedSource<<5e92c454a8af6e9adf7a92ab1ec092b4>>
 * @relayHash bd7c883ca62fec8638ba84ea336b2321
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 949dc2fd39019cf39ada8cacca907201f62bbe585e7daaae9c36adfb838b5f6d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceRoleType = "CUSTOM" | "SYSTEM" | "%future added value";
export type RoleSelectionSectionRolesQuery$variables = Record<PropertyKey, never>;
export type RoleSelectionSectionRolesQuery$data = {
  readonly spaceRolesByCriteria: {
    readonly nodes: ReadonlyArray<{
      readonly roleDescription: string;
      readonly roleDisplayName: string;
      readonly roleId: string;
      readonly roleType: SpaceRoleType;
      readonly spacePermissionList: ReadonlyArray<{
        readonly description: string | null | undefined;
        readonly displayName: string;
        readonly id: string;
        readonly priority: number;
        readonly requiredSpacePermissions: ReadonlyArray<string | null | undefined> | null | undefined;
      }>;
    } | null | undefined>;
  } | null | undefined;
};
export type RoleSelectionSectionRolesQuery = {
  response: RoleSelectionSectionRolesQuery$data;
  variables: RoleSelectionSectionRolesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "SpaceRoleConnection",
    "kind": "LinkedField",
    "name": "spaceRolesByCriteria",
    "plural": false,
    "selections": [
      {
        "concreteType": "SpaceRole",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "roleId"
          },
          {
            "kind": "ScalarField",
            "name": "roleDisplayName"
          },
          {
            "kind": "ScalarField",
            "name": "roleDescription"
          },
          {
            "kind": "ScalarField",
            "name": "roleType"
          },
          {
            "concreteType": "SpacePermissionInfo",
            "kind": "LinkedField",
            "name": "spacePermissionList",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "priority"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              {
                "kind": "ScalarField",
                "name": "requiredSpacePermissions"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "RoleSelectionSectionRolesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RoleSelectionSectionRolesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "bd7c883ca62fec8638ba84ea336b2321",
    "id": "949dc2fd39019cf39ada8cacca907201f62bbe585e7daaae9c36adfb838b5f6d",
    "metadata": {},
    "name": "RoleSelectionSectionRolesQuery",
    "operationKind": "query",
    "text": "query RoleSelectionSectionRolesQuery{spaceRolesByCriteria{nodes{roleId,roleDisplayName,roleDescription,roleType,spacePermissionList{id,priority,displayName,description,requiredSpacePermissions}}}}"
  }
};
})();

(node as any).hash = "cc445348302affe2962240cd1154aad8";

export default node;
